<script setup lang="ts">
</script>
<template>
  <div class="tw-flex tw-flex-col tw-h-full tw-w-full tw-p-4 tw-animate-pulse">
    <!-- Graph Title -->
    <div class="tw-h-6 tw-bg-connx-grey-tint-80 tw-rounded tw-w-1/3 tw-mb-4"></div>

    <!-- Graph container with flexible height -->
    <div class="tw-relative tw-w-full tw-grow-1 tw-h-full tw-overflow-hidden tw-rounded">
      <!-- Optional horizontal grid lines -->
      <div class="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-between tw-pointer-events-none">
        <div class="tw-border-t tw-border-dashed tw-border-connx-grey-tint-80"></div>
        <div class="tw-border-t tw-border-dashed tw-border-connx-grey-tint-80"></div>
        <div class="tw-border-t tw-border-dashed tw-border-connx-grey-tint-80"></div>
      </div>

      <!-- Simulated line path -->
      <svg
        class="tw-absolute tw-inset-0 tw-w-full tw-h-full"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
      >
        <polyline
          fill="none"
          stroke="#d1d5db"
          stroke-width="2"
          points="0,30 20,20 40,25 60,15 80,18 100,10"
          class="tw-animate-pulse"
        />
      </svg>
    </div>

    <!-- X-axis labels placeholder -->
    <div class="tw-mt-4 tw-h-4 tw-bg-connx-grey-tint-80 tw-rounded tw-w-1/2"></div>
  </div>
</template>